import React from 'react';
import ProgressiveImage from 'react-progressive-image';
import styled from 'styled-components';
import fileExtension from 'file-extension';
//
import GifVideo from './../gif-video';
//

export default ({ caption, dimensions, url, ...rest }) => {
  if (!url) {
    return null;
  }

  if (fileExtension(url).replace(/\?.*$/g, '') === 'gif') {
    return <GifVideo url={url} />;
  }

  const src = url;

  return (
    <Figure
      {...rest}
      style={{
        paddingBottom: `${(100 * dimensions.height) / dimensions.width}%`
      }}
    >
      <ProgressiveImage src={src}>
        {(src, loading) => (
          <Img src={src} alt={caption} style={{ opacity: loading ? 0 : 1 }} />
        )}
      </ProgressiveImage>
    </Figure>
  );
};
//
const Figure = styled.figure`
  background-color: #f4f7f9;
  height: 0;
  margin: 0;
  overflow: hidden;
  position: relative;
  width: 100%;
`;

const Img = styled.img`
  bottom: 0;
  left: 0;
  object-fit: cover;
  position: absolute;
  right: 0;
  top: 0;
  transition: opacity 420ms ease-in;
  width: 100%;
`;
